{
  "DATA_ASSISTANT": {
    "TITLE": "Data Asistent",
    "NEW_CONVERSATION": "+ Nový",
    "LOADING": "Načítání...",
    "LOADING_MESSAGES": "Načítání zpráv...",
    "THINKING": "Přemýšlím...",
    "UNTITLED": "Nepojmenovaná konverzace",
    "NO_CONVERSATIONS": "Zatím žádné konverzace. Klikněte na \"+ Nový\" pro začátek.",
    "EMPTY_STATE": "Vyberte konverzaci nebo vytvořte novou.",
    "SEND": "Odeslat",
    "PLACEHOLDER": "Co pro vás můžu zjistit?",
    "SHOW_SQL": "Zobrazit SQL",
    "NO_ROWS": "Žádné výsledky.",
    "DELETE": "\u00d7",
    "DELETE_CONFIRM": "Smazat konverzaci",
    "DELETE_CONFIRM_DESCRIPTION": "Opravdu chcete smazat tuto konverzaci? Tuto akci nelze vrátit zpět.",
    "DELETE_CONFIRM_YES": "Smazat",
    "CHAT": "Chat",
    "REPORTS": "Reporty",
    "SAVE_TO_REPORT": "Uložit do reportu",
    "NEW_REPORT": "Nový report",
    "REPORT_NAME": "Název reportu",
    "NO_REPORTS": "Zatím žádné reporty",
    "REPORTS_EMPTY_STATE": "Vyberte report nebo vytvořte nový.",
    "REPORT_SAVED": "Uloženo do reportu",
    "DELETE_REPORT_CONFIRM": "Smazat report",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Opravdu chcete smazat tento report? Všechny uložené položky budou odstraněny.",
    "DELETE_ITEM_CONFIRM": "Odebrat položku",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Opravdu chcete odebrat tuto položku z reportu?",
    "EXPORT_CSV": "Stáhnout CSV",
    "REFRESH": "Obnovit",
    "QUERY_RUNNING": "Spouštím dotaz...",
    "QUERY_FAILED": "Dotaz selhal",
    "AUTO_REFRESH": "Automatické obnovení",
    "AUTO_REFRESH_NONE": "Ručně",
    "AUTO_REFRESH_30S": "30 sekund",
    "AUTO_REFRESH_1M": "1 minutu",
    "AUTO_REFRESH_5M": "5 minut",
    "AUTO_REFRESH_10M": "10 minut",
    "EDIT_MESSAGE": "Upravit zprávu",
    "RENAME_REPORT": "Přejmenovat report",
    "RENAME_ITEM": "Přejmenovat položku",
    "MOVE_UP": "Přesunout nahoru",
    "MOVE_DOWN": "Přesunout dolů",
    "COLLABORATORS": {
      "BUTTON": "Spolupracovníci",
      "TITLE": "Spolupracovníci reportu",
      "DESCRIPTION": "Vyberte, kteří agenti a týmy mají přístup k tomuto reportu.",
      "AGENTS": "Agenti",
      "TEAMS": "Týmy",
      "SELECT_AGENTS": "Vyberte agenty",
      "SELECT_TEAMS": "Vyberte týmy",
      "SAVE": "Uložit",
      "SAVED": "Spolupracovníci aktualizováni",
      "SAVE_FAILED": "Uložení spolupracovníků selhalo"
    }
  },
  "DATA_ASSISTANT_CHAT": "Chat",
  "DATA_ASSISTANT_REPORTS": "Reporty"
}
